var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-if-bot',[_c('div',{staticClass:"blog__container"},[_c('h3',{on:{"click":function($event){return _vm.readFile()}}},[_vm._v("1. Newsletter - November 2023")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }